var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "relative bg-gray-50 pt-[50%] overflow-hidden file-thumbnail h-100" };
const _hoisted_2 = {
    key: 0,
    class: "hover-name text-white absolute bottom-2 left-2 image-hover-media"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = ["href"];
const _hoisted_5 = {
    key: 1,
    class: "hover-option image-hover-media"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
    key: 0,
    class: "px-2 py-2 file-name-container"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
import { DotsVerticalIcon, Link02Icon, TextInputIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIButton, UIDropdown, UITextSmMedium, UITextXsRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import { computed, h, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import { copyToClipboard } from '../util/helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UnsplashFile',
    props: {
        image: {}
    },
    emits: ["onClickImage"],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        const store = useStore();
        const props = __props;
        const emit = __emit;
        const appName = ref('dev_leadconnector');
        const gradientStyle = computed(() => {
            return hover.value || hoverDropdown.value
                ? {
                    background: 'linear-gradient(0deg, rgba(34,34,34,1) 0%, rgba(255,255,255,0)  75%)',
                    'z-index': '1000',
                }
                : {};
        });
        const hover = ref(false);
        const hoverDropdown = ref(false);
        const onChangeOption = (e) => __awaiter(this, void 0, void 0, function* () {
            hoverDropdown.value = false;
            switch (e) {
                case 'copy': {
                    copyToClipboard(props.image.urls.regular);
                    sendNotification({
                        title: t('common.copiedClipboard'),
                        type: 'success',
                    });
                    break;
                }
                case 'addUnsplashImage': {
                    const params = {
                        altId: store.altId,
                        altType: store.altType,
                        url: props.image.urls.regular,
                        source: 'unsplash',
                    };
                    try {
                        yield MediaService.addFile(params);
                        sendNotification({
                            title: t('common.successfullyAdded'),
                            type: 'success',
                        });
                    }
                    catch (error) {
                        sendNotification({
                            title: t('common.failedToAddMedia'),
                            type: 'error',
                        });
                    }
                    break;
                }
                default:
                    break;
            }
        });
        const contextMenuItems = [
            {
                icon() {
                    return h(renderIcon(Link02Icon), null, {});
                },
                label: t('common.copy'),
                key: 'copy',
            },
            {
                icon() {
                    return h(renderIcon(TextInputIcon), null, {});
                },
                label: t('common.addImageToMedia'),
                key: 'addUnsplashImage',
            },
        ];
        const toggleDropdown = e => {
            hoverDropdown.value = !hoverDropdown.value;
            e.stopPropagation();
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["relative overflow-hidden bg-white rounded-lg aspect-square shadow-md group ring-1 ring-black ring-opacity-5", { 'hover-effect': hover.value }]),
                onMouseenter: _cache[2] || (_cache[2] = ($event) => (hover.value = true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event) => (hover.value = false))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_ctx.image.user)
                                ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                    key: 0,
                                    class: "text-white"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('common.photoBy')) + " ", 1),
                                        _createElementVNode("a", {
                                            target: "blank",
                                            class: "text-blue-500",
                                            href: `https://unsplash.com/@${_ctx.image.user.username}?utm_source=${appName.value}&utm_medium=referral`
                                        }, _toDisplayString(_ctx.image.user.name), 9, _hoisted_3),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.on')) + " ", 1),
                                        _createElementVNode("a", {
                                            target: "blank",
                                            class: "text-blue-500",
                                            href: `https://unsplash.com/?utm_source=${appName.value}&utm_medium=referral`
                                        }, "Unsplash", 8, _hoisted_4)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (hover.value || hoverDropdown.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_unref(UIDropdown), {
                                options: contextMenuItems,
                                id: 'dropdown',
                                placement: "bottom",
                                onClickoutside: _cache[0] || (_cache[0] = ($event) => (hoverDropdown.value = false)),
                                show: hoverDropdown.value,
                                onSelect: onChangeOption
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIButton), {
                                        id: "media-file-dropdown",
                                        type: "default",
                                        size: "small",
                                        disabled: false,
                                        loading: false,
                                        ghost: false,
                                        quaternary: true,
                                        circle: false,
                                        text: false,
                                        onClick: toggleDropdown
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(DotsVerticalIcon), { class: "w-5 h-5 text-black cursor-pointer" })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["show"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "absolute inset-0 w-full h-full overflow-hidden rounded-t-lg file-thumbnail-inner",
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('onClickImage')))
                    }, [
                        _createElementVNode("div", {
                            class: "relative w-full h-full image-hover-media",
                            style: _normalizeStyle(gradientStyle.value)
                        }, null, 4),
                        _createElementVNode("img", {
                            src: ((_a = _ctx.image) === null || _a === void 0 ? void 0 : _a.urls) ? _ctx.image.urls.thumb : '',
                            alt: "",
                            class: "absolute inset-0 object-cover w-full h-full"
                        }, null, 8, _hoisted_6)
                    ])
                ]),
                false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(UITextSmMedium), { class: "truncate" }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UITooltip), null, {
                                    trigger: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.image.id), 1)
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.image.id), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (_ctx.image.user)
                            ? (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                key: 0,
                                class: "text-gray-600"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.photoBy')) + " ", 1),
                                    _createElementVNode("a", {
                                        target: "blank",
                                        class: "text-blue-500",
                                        href: `https://unsplash.com/@${_ctx.image.user.username}?utm_source=${appName.value}&utm_medium=referral`
                                    }, _toDisplayString(_ctx.image.user.name), 9, _hoisted_8),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.on')) + " ", 1),
                                    _createElementVNode("a", {
                                        target: "blank",
                                        class: "text-blue-500",
                                        href: `https://unsplash.com/?utm_source=${appName.value}&utm_medium=referral`
                                    }, "Unsplash", 8, _hoisted_9)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 34));
        };
    }
});
